<template>
    <div>
      <!-- 增加人员按钮 -->
      <el-button class="el-icon-plus" type="primary" @click="handleAddUser()" style="margin-bottom: 20px;">
        增加人员
      </el-button>
      <!-- 修改按钮 -->
      <el-button class="el-icon-user" type="primary" @click="handleEdit()" style="margin-bottom: 20px;">
        查看我的信息
      </el-button>
      <!-- 表格 -->
      <el-table :data="tableData" style="width: 100%">
        <!-- 用户名 -->
        <el-table-column prop="username" label="用户名" width="150"></el-table-column>
  
        <!-- 头像 -->
        <el-table-column label="头像" width="100">
          <template slot-scope="scope">
            <el-avatar :src="scope.row.headPicture"></el-avatar>
          </template>
        </el-table-column>
  
        <!-- 性别 -->
        <el-table-column prop="gender" label="性别" width="100">
          <template slot-scope="scope">
            <i v-if="scope.row.sex === 1" class="el-icon-male"></i>
            <i v-else-if="scope.row.sex === null" >Empty</i>
            <i v-else class="el-icon-female"></i>
          </template>
        </el-table-column>
  
        <!-- 最后一次登录时间 -->
        <el-table-column prop="lastLoginTime" label="最后一次登录时间" width="180"></el-table-column>
  
        <!-- 手机号 -->
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
  
        <!-- 邮箱 -->
        <el-table-column prop="email" label="邮箱" width="200"></el-table-column>

      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px; text-align: right;"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
      ></el-pagination>
  
      <!-- 增加用户的对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
        <el-form :model="registerUser" label-width="80px">
          <el-form-item label="用户名">
            <el-input v-model="registerUser.username"></el-input>
          </el-form-item>
          
          <el-form-item label="性别">
            <el-radio-group v-model="registerUser.sex">
              <el-radio label=1>男</el-radio>
              <el-radio label=2>女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="registerUser.phone"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="registerUser.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleConfirm">确认</el-button>
        </span>
      </el-dialog>
       <!-- 第一个弹窗：输入用户名和密码 -->
    <el-dialog title="验证身份" :visible.sync="firstDialogVisible" width="30%">
      <el-form :model="authForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="authForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="authForm.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="firstDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAuth()">确认</el-button>
      </span>
    </el-dialog>
    <!-- 第二个弹窗：修改个人信息 -->
    <el-dialog title="修改个人信息" :visible.sync="secondDialogVisible" width="30%">
      <el-form :model="userForm" label-width="100px">
        <el-form-item label="头像">
            <el-upload
            class="avatar-uploader"
            action="http://www.wjyzlj.cn/pet/file/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="headPicture" :src="headPicture" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="userForm.username"></el-input>
        </el-form-item>
        <el-form-item label="性别">
            <el-radio  v-model="userForm.sex" label=1>男</el-radio>
            <el-radio  v-model="userForm.sex" label=2>女</el-radio>
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="userForm.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input type="password" v-model="userForm.password2"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="userForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="userForm.email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="secondDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit()">提交</el-button>
      </span>
    </el-dialog>
    </div>
  </template>
  
  <script>
import axios from 'axios';

  export default {
    name:'AdminTable',
    data() {
      return {
        allData:[],
        // 表格数据
        tableData: [],
        // 分页相关数据
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页显示条数
        total:0,
        // 对话框是否显示
        dialogVisible: false,
        firstDialogVisible:false,
        secondDialogVisible:false,
        // 对话框标题
        dialogTitle: '增加人员',
        // 表单数据
        registerUser:{
        username:'',//用户名
        password:'root',//密码
        password2:'root',//确认密码
        sex: 1,//性别
        email:'',//邮箱
        phone:'',//手机号
        introduction:'',//个人简介
        headPicture: 'http://www.wjyzlj.cn/bsPic/defaultHeader.jpg'//头像地址
      },
        // 当前操作类型（add/edit）
        currentAction: 'add',
        // 当前编辑的用户索引
        currentEditIndex: -1,
        // 身份验证表单
      authForm: {
        username: '',
        password: '',
      },
      // 用户信息表单
      userForm: {
        id:-1,
        headPicture: '',
        sex:0,
        username: '',
        password: '',
        password2: '',
        phone: '',
        email: '',
      },

      };
    },
    created(){
        this.queryAdmin()
    },
    methods: {
        handleAvatarSuccess(res, file) {
        this.userForm.headPicture = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      // 打开增加人员对话框
      handleAddUser() {
        this.dialogTitle = '添加';
        this.currentAction = 'add';
        this.form = {
          username: '',
          avatar: '',
          gender: '',
          phone: '',
          email: '',
        };
        this.dialogVisible = true;
      },
      // 确认增加/修改
      handleConfirm() {
        this.dialogVisible = false;
      },
      // 当前页码改变
      handlePageChange(page) {
        this.currentPage = page;
        this.queryAdmin()
      },
      //查询所有管理员
      queryAdmin(){
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `${token}`;
        axios.get(`http://www.wjyzlj.cn/pet/user/page?current=${this.currentPage}&pageSize=${this.pageSize}`)
        .then( response => {
            this.allData = response.data.data.records
            //过滤出管理员
            this.tableData = this.allData.filter(item => item.userType == 1);
            this.total = this.tableData.length
        })
        .catch( error => {
            console.log(error)
        })
      },
      //
      handleEdit(){
        this.firstDialogVisible = true
        const currentId = this.getCookie('id')
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common['Authorization' ] = `${token}`
        this.authForm.username = this.getCookie('username')
        axios.get(`http://www.wjyzlj.cn/pet/user/${currentId}`)
        .then( response => {
           
        })
        .catch(error => {
            console.log(error)
        })
      },
      //验证用户名密码
      handleAuth(){
        axios.post('http://www.wjyzlj.cn/pet/user/login',this.authForm)
        .then( response => {
            if(response.data.code == 200){
                console.log(this.authForm)
                this.userForm.username = this.getCookie('username')
                this.secondDialogVisible = true
                this.firstDialogVisible = false
            }
        })
        .catch( error => {
            console.log(error)
        })
      },
      //处理修改提交
      handleSubmit(){
        this.id = this.getCookie('id')
        console.log(this.userForm)
        axios.put('http://www.wjyzlj.cn/pet/user',this.userForm)
        .then( response => {
            console.log(response.data)
        })
        .catch(error => {
            this.$message.error('修改失败')
        })
      },
      getCookie(name) {
            // 获取所有cookie字符串
            let cookies = document.cookie.split(';');
            // 遍历每个cookie
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i].trim();  // 去除空格
                if (cookie.startsWith(name + '=')) {
                    return cookie.substring(name.length + 1);  // 返回cookie值
                }
            }
            
            return null;  // 如果没有找到指定的cookie，返回null
    }
    },
  };
  </script>
  
  <style scoped>
  .el-avatar {
    vertical-align: middle;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>